import {ProductListColumnsParams, ProductListPreference} from "./types";

const getPreferences = ({
  activeColumns,
  hasGrossWeightManual,
  hasNetWeightManual,
  hasPalleteCnt,
  hasPalleteType,
  hasVolumeCartoon,
  hasVolumeManual,
}: ProductListColumnsParams): ProductListPreference[] => {
  const allColumns = [
    {
      id: 'id',
      width: 40,
    },
    {
      id: 'name',
      width: 120,
    },
    {
      id: 'pieces',
      width: 68,
    },
    {
      id: 'places_manual',
      width: 60,
    },
    {
      id: 'pieces_in_cartoon',
      width: 68,
    },
    {
      id: 'unit_price',
      width: 80,
    },
    {
      id: 'price',
      width: 90,
    },
    ...(!hasVolumeCartoon ? [] : [
      {
        id: 'volume_cartoon',
        width: 68,
      }
    ]),
    ...(!hasVolumeManual ? [] : [
      {
        id: 'volume_manual',
        width: 68,
      }
    ]),
    ...(!hasNetWeightManual ? [] : [
      {
        id: 'net_weight_manual',
        width: 68,
      }
    ]),
    ...(!hasGrossWeightManual ? [] : [
      {
        id: 'gross_weight_manual',
        width: 68,
      }
    ]),
    {
      id: 'volume_total',
      width: 92,
    },
    {
      id: 'net_weight_cartoon',
      width: 80,
    },
    {
      id: 'gross_weight_cartoon',
      width: 80,
    },
    {
      id: 'net_weight_total',
      width: 80,
    },
    {
      id: 'gross_weight_total',
      width: 80,
    },
    ...(!hasPalleteCnt ? [] : [
      {
        id: 'pallete_cnt',
        width: 68,
      }
    ]),
    ...(!hasPalleteType ? [] : [
      {
        id: 'pallete_type',
        width: 68,
      }
    ]),
    {
      id: 'settings',
      width: 40,
    },
  ];

  return allColumns.filter((column) => activeColumns.includes(column.id));
}

export default getPreferences
